import * as Api from '@ViewModels';
import serviceTitanLogo from '../../../../assets/logo_servicetitan_small.png';
import { baseStyleSheet } from '../../../../styles/styles';
import { GenericIntegrationGraphic } from '../../../svgs/graphics/GenericIntegrationGraphic';
import { IntegrationCard, useIntegrationCard } from '../IntegrationCard';
import { styleSheet } from './styles';

export const DashboardServiceTitanIntegrationCard = () => {
	const { getLogoImgProps, getCloseButtonProps, getCtaButtonProps, getIntegrationTitleProps, showCard } =
		useIntegrationCard({
			closeIntegrationEventName: 'ServiceTitanIntegrationClosed',
			enableUrlPath: '/integrations/ServiceTitan',
			integrationEnableEventName: 'ServiceTitanIntegrationEnableClick',
			pendingAction: Api.PendingActions.ConnectServiceTitan,
			checkApiPendingAction: true,
		});

	if (!showCard) {
		return null;
	}

	return (
		<IntegrationCard
			closeButtonProps={getCloseButtonProps()}
			IntegrationGraphic={GenericIntegrationGraphic}
			headerLabel='ServiceTitan Integration'
			logoBgColor='#18191D'
			logoImgProps={getLogoImgProps({ alt: 'ServiceTitan Logo', src: serviceTitanLogo })}
			ctaButtonProps={getCtaButtonProps({
				children: 'Connect with ServiceTitan',
				styleDeclaration: [baseStyleSheet.ctaButtonReverse, styleSheet.ctaButton],
			})}
			integrationTitleProps={getIntegrationTitleProps({
				styleDeclaration: styleSheet.integrationTitle,
			})}
		>
			<p>
				We are excited to announce that you can integrate your ServiceTitan account with Levitate. With this
				integration, we will have the ability to pull client information, including names, email, phone number, and more
				&mdash; making staying in touch even easier.
			</p>
		</IntegrationCard>
	);
};
